import type { ReactNode } from 'react';
import { useField } from 'formik';
import { Switch } from '@redis-ui/components';

interface FormSwitchProps {
  includeFieldProps?: boolean;
  name: string;
  dataTestId?: string;
  id?: string;
  disabled?: boolean;
  readOnly?: boolean;
  onChange?: (value: boolean) => void;
  touchedOnChange?: boolean;
  titleOn?: ReactNode;
  titleOff?: ReactNode;
  ariaLabel?: string;
}

const FormSwitch = ({
  includeFieldProps = true,
  name,
  id,
  disabled,
  readOnly,
  dataTestId,
  onChange,
  touchedOnChange,
  titleOn,
  titleOff,
  ariaLabel
}: FormSwitchProps) => {
  const [field, , helpers] = useField(name);
  const inputId = id || name;

  const handleChange = (newValue: boolean) => {
    if (onChange) {
      onChange(newValue);
    } else {
      helpers.setValue(newValue);
    }

    if (touchedOnChange) {
      helpers.setTouched(true);
    }
  };

  return (
    <Switch
      {...(includeFieldProps ? field : { name })}
      id={inputId}
      data-testid={`switch--${dataTestId ?? inputId}`}
      disabled={disabled}
      readOnly={readOnly}
      checked={field.value}
      onCheckedChange={handleChange}
      titleOn={titleOn}
      titleOff={titleOff}
      aria-label={ariaLabel}
    />
  );
};

export default FormSwitch;
